// ─── Grouped reads (W4) ─────────────────────────────────────────
/**
 * The bucket that holds entities carrying no `list` label.
 *
 * This is a real bucket with a real key, not a null hole. Every task and file
 * in production is in it — the labels tables have no rows yet — so it is the
 * ordinary case and the default view, and a client must be able to name it,
 * link to it and render it exactly like any other bucket.
 */
export const UNCATEGORISED_LIST_KEY = 'uncategorised';
//# sourceMappingURL=labels.js.map